<template>
  <div class="shortlist-dashboard-container">
    <div class="shortlist-dashboard">
      <div class="shortlist-dashboard-content">
        <div class="findspace-nav-container">
          <div class="shortlist-dashboard-heading">Hi{{ user ? ' ' + user.first_name : ''}}, start your shortlist here</div>
          <inline-location-search class="hirer-tools" />
          <div class="tabbed-nav-container">
            <div class="tabbed-nav" :class="{active: activeNav == 'current'}" @click="activeNav = 'current'">Current</div>
            <div class="tabbed-nav" :class="{active: activeNav == 'archive'}" @click="activeNav = 'archive'" v-if="archivedShortlists.length">Archive</div>
          </div>
          <div class="shortlist-nav">
            <div class="button primary" @click="addNewShortlist">New Shortlist</div>
          </div>
        </div>
        <div class="shortlist-list">
          <template v-if="shortlists.length">
            <div class="shortlist-list-heading tablet-hidden">
              <div>Shortlist Name</div>
              <div>Date Created</div>
              <div>Listings</div>
              <div>Brand/Agency</div>
            </div>
            <div class="shortlist-block" v-for="shortlist in shortlists" :key="'shortlist-' + shortlist.id">
              <div class="shortlist-label" :class="{archived: activeNav == 'archive'}" @click="viewShortlist(shortlist)">
                <div class="shortlist-date tablet-only">{{ shortlist.created_at ? new Date(shortlist.created_at).toLocaleDateString() : '' }}</div>
                <div>{{ shortlist.label }}</div>
              </div>
              <div class="shortlist-date tablet-hidden" :class="{archived: activeNav == 'archive'}" @click="viewShortlist(shortlist)">{{ shortlist.created_at ? new Date(shortlist.created_at).toLocaleDateString() : '' }}</div>
              <div class="shortlist-listings-container" :class="{archived: activeNav == 'archive'}" @click="viewShortlist(shortlist)">
                <div class="shortlist-listings">{{ shortlist.listings.length ? shortlist.listings.length : 'No' }} listings</div>
              </div>
              <div class="shortlist-brand-label">{{
                shortlist.agency_name && shortlist.brand_name
                  ? shortlist.brand_name + '/' + shortlist.agency_name
                  : shortlist.agency_name ? shortlist.agency_name : shortlist.brand_name
              }}</div>
              <div class="shortlist-buttons">
                <div
                  class="share-button"
                  v-if="shortlist.listings.length && activeNav == 'current'"
                  @click="cloneShortlist(shortlist)"
                  v-floating-tooltip="'Clone shortlist'"
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <image xlink:href="/images/icons/copy.svg" />
                  </svg>
                </div>
                <div
                  class="share-button"
                  v-if="shortlist.listings.length && activeNav == 'current'"
                  @click="openShareModal(shortlist)"
                  v-floating-tooltip="'Share shortlist'"
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <image xlink:href="/images/icons/export.svg" />
                  </svg>
                </div>
                <div class="share-button"
                  @click="editShortlist(shortlist)"
                  v-floating-tooltip="'Edit shortlist'">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <image xlink:href="/images/icons/edit-v3.svg" />
                  </svg>
                </div>
                <div
                  class="archive-button button-slide-hover"
                  v-if="shortlist.listings.length && activeNav == 'current'"
                  @click="archiveShortlist(shortlist)"
                  v-floating-tooltip="'You can archive a shortlist that is no longer in use. Archived shortlists can be restored at any time from the archive tab'"
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <image xlink:href="/images/icons/trash-2.svg" />
                  </svg>
                </div>
                <div
                  class="archive-button button-slide-hover"
                  v-if="shortlist.listings.length && activeNav == 'archive'"
                  @click="unarchiveShortlist(shortlist)"
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <image xlink:href="/images/icons/restore.svg" />
                  </svg>
                </div>
                <a href="/explore" class="explore-spaces-button button-slide-hover" v-if="!shortlist.listings.length">
                  Explore Spaces
                </a>
              </div>
            </div>
          </template>
          <!-- No shortlists block -->
          <template v-else>
            <div class="no-shortlists-container">
              <div class="no-shortlists-icon">
                <svg xmlns="http://www.w3.org/2000/svg">
                  <image xlink:href="/images/icons/archive-book.svg" />
                </svg>
              </div>
              <div class="no-shortlists-heading">
                You have no shortlists
              </div>
              <div class="no-shortlists-text">
                Create one now and get started
              </div>
              <div class="no-shortlists-btn button primary" @click="addNewShortlist">
                Create a shortlist
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="lets-chat-block tablet-hidden">
        <div class="question-block">
          <svg xmlns="http://www.w3.org/2000/svg">
            <image xlink:href="/images/icons/message-question.svg" />
          </svg>
        </div>
        <div class="lets-chat-heading">Need any help finding your space or have a question?</div>
        <div class="lets-chat-text">We make it easy to search, shortlist and book your next location</div>
        <div class="lets-chat-btn-container">
          <button class="button lets-chat-btn-transparent" @click="openChat">Chat to us now</button>
          <button class="button view-lookbook-btn-transparent mt-4" @click="viewLookbooks">View APS Shortlists</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNav: 'current'
    }
  },
  methods: {
    goToExplore() {
        window.location = '/explore'
    },
    addNewShortlist() {
      this.$store
        .dispatch("modals/show", {
          title: "Create a new shortlist",
          type: "shortlist-add",
          maskCanDismiss: false,
          narrow: true,
        })
        .then(() => {})
        .catch(() => {});
    },
    editShortlist(shortlist) {
      console.log(shortlist)
      this.$store
        .dispatch("modals/show", {
          title: "Edit shortlist",
          type: "shortlist-add",
          maskCanDismiss: false,
          narrow: true,
          data: shortlist
        })
        .then(() => {})
        .catch(() => {});
    },
    archiveShortlist (shortlist) {
      this.$store.dispatch('modals/show', {
        title: 'Archive shortlist?',
        cancelLabel: 'Cancel',
        confirmLabel: 'Archive shortlist',
        confirmMessage: `Are you sure you want to archive the shortlist <b class="wt-bold">${shortlist.label}</b>?`,
        data: shortlist,
        narrow: true
      })
      .then(() => {
        axios.delete(`/api/account/shortlists/${shortlist.id}`)
          .then(() => {
            this.$store.commit('user/archiveShortlist', shortlist.id)
            this.$toasted.show(`Your shortlist "${shortlist.label}" has been archived.`, {
              type: 'success'
            })
          })
          .catch(() => {
            this.$toasted.show('Your shortlist could not be archived, please try again.', {
              type: 'error'
            })
          })
          .then(() => {})
      })
      .catch(() => {})
    },
    unarchiveShortlist (shortlist) {
      this.$store.dispatch('modals/show', {
        title: 'Restore shortlist?',
        cancelLabel: 'Cancel',
        confirmLabel: 'Restore shortlist',
        confirmMessage: `Are you sure you want to restore the shortlist <b class="wt-bold">${shortlist.label}</b>?`,
        data: shortlist,
        narrow: true
      })
      .then(() => {
        axios.post(`/api/account/shortlists/${shortlist.id}/unarchive`)
          .then(() => {
            this.$store.commit('user/restoreShortlist', shortlist.id)
            this.$toasted.show(`Your shortlist "${shortlist.label}" has been restored.`, {
              type: 'success'
            })
            if (!this.archivedShortlists.length) {
              this.activeNav = 'current'
            }
          })
          .catch(() => {
            this.$toasted.show('Your shortlist could not be restored, please try again.', {
              type: 'error'
            })
          })
          .then(() => {})
      })
      .catch(() => {})
    },
    cloneShortlist (shortlist) {
      this.$store.dispatch('modals/show', {
        title: 'Clone shortlist?',
        cancelLabel: 'Cancel',
        confirmLabel: 'Clone shortlist',
        confirmMessage: `Are you sure you want to clone the shortlist <b class="wt-bold">${shortlist.label}</b>?`,
        data: shortlist,
        narrow: true
      })
      .then(() => {
        axios.post(`/api/account/shortlists/${shortlist.id}/clone`)
          .then((response) => {
            this.$store.commit('user/updateShortlists', response.data)
            this.$toasted.show(`Your shortlist "${shortlist.label}" has been clone.`, {
              type: 'success'
            })
          })
          .catch(() => {
            this.$toasted.show('Your shortlist could not be clone, please try again.', {
              type: 'error'
            })
          })
          .then(() => {})
      })
      .catch(() => {})
    },
    viewShortlist(shortlist) {
      if(this.activeNav == 'current') {
        this.$store.commit('findspace/setSubpage', { subpage: 'view', item: shortlist })
      }
    },
    openShareModal(shortlist) {
      this.$store
        .dispatch("modals/show", {
          type: "shortlist-share",
          maskCanDismiss: false,
          headless: true,
          narrow: true,
          data: {
            shortlist: shortlist
          }
        });
    },
    openChat() {
      this.$store.dispatch("intercom/openNewChat");
    },
    viewLookbooks() {
      this.$store.commit('findspace/navigateToSubpage', { page: 'shortlists', subpage: 'lookbooks' })
    }
  },
  computed: {
    archivedShortlists() {
      return this.$store.getters["user/archivedShortlists"].sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    },
    shortlists() {
      if (this.activeNav == 'current') {
        return this.$store.getters["user/shortlists"].sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
      } else {
        return this.archivedShortlists;
      }
    },
    user () {
      return this.$store.getters['user/account']
    },
  }
}
</script>
